module.exports = __webpack_public_path__ + "static/media/sijeLogo_PEL2020.fa1673d8.svg";